<template>
    <section v-if="this.selectedGroup">
      <BreadCrumbList v-if="groupName">
        <span>{{this.groupName}}</span>
        <span>{{this.$t("app.dashboard.sidemenu.variable")}}</span>
      </BreadCrumbList>
      <VariablesTable
        :VariableList="VariableList"
        :Owned="isOwned"
      />
      <hr>
      <ul class="btn-list">
        <li>
          <a
            v-if="this.loadingflag == false"
            class="btn-square-little-rich"
            @click="updateVariableList"
          >
            <b-icon pack="fas" icon="sync-alt"></b-icon>
            <span class="button_text">{{$t("general.refresh")}}</span>
          </a>
          <a
            v-else
            class="btn-square-little-rich"
          >
            <div id="loader"></div>
          </a>
        </li>
        <li>
          <a 
            class="btn-square-little-rich"
            @click="UpdateUserAction"
          >
            <b-icon  pack="fas" icon="chart-area"></b-icon>
            <span class="button_text">{{$t("app.dashboard.variable.overlay")}}</span>
          </a>
        </li>
      </ul>
    </section>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import GroupSelectHandler from './GroupSelectHandler'
import VariablesTable from './VariablesTable'
import BreadCrumbList from '../../../view/BreadCrumbList'

export default GroupSelectHandler.extend({
    components: { VariablesTable, BreadCrumbList },
    data() {
        return {
          path: "",
          loadingflag: false,
          watchFn: null,
        }
    },
    computed: {
      ...mapState({
        isOwned: state => state.groups.selected && state.groups.cached[state.groups.selected] && state.groups.cached[state.groups.selected].OwnerID === state.account.id,
        groupName: state => state.groups.selected && state.groups.cached[state.groups.selected] && state.groups.cached[state.groups.selected].Name,
        VariableList: state => state.groups.selected && state.groups.cached[state.groups.selected] ? state.groups.cached[state.groups.selected].Variables : []
      })
    },
    mounted() {
      this.watchFn = this.$store.watch(state => {
        const opts = state.dashboard.options
        return {useraction: opts.useraction, checkedrows: opts.checkedrows, selected: opts.selected, delete: opts.delete}
      }, (update) => {
        
        if(update.useraction == 'overlay'){
            //パラメータを作成
            update.checkedrows.forEach(element => {
                this.path += "&" + element.VariableID
            });
            this.$router.push({path: `/dashboard/group/${this.selectedGroup}/graph/${this.path}`}, () => {})
            this.$store.dispatch('UpdateUserAction', null)
            this.$store.dispatch('UpdateCheckedRows',[])
        } else if (update.selected){
            if(update.delete == false){
                this.$router.push({path: `/dashboard/group/${this.selectedGroup}/graph/&${update.selected.VariableID}`}, () => {})
                this.$store.dispatch('UpdateCheckedRows',[])
            }else{
                this.$store.dispatch('UpdateSelected',false)
            }
        }
      })
    },
    destroyed() {
      this.$store.dispatch('UpdateSelected',null)
      this.watchFn()
    },
    methods: {
        updateVariableList(){
          this.$store.dispatch('UpdateCheckedRows',[])
          this.loadingflag = true
          setTimeout(() => {
            this.getGroup({gId: this.$store.state.groups.selected, opts: {refresh: true}})
            .catch(() => {
              this.$buefy.toast.open({
                  duration: 7000,
                  message: this.$t('app.dashboard.graph.error_warning'),
                  position: "is-top",
                  type: "is-danger"
              })
              return Promise.resolve()
            })
            .finally(() => this.loadingflag = false)
          }, 1.5 * 1000)
        },
        UpdateUserAction(){
            if(this.$store.state.dashboard.options.checkedrows.length == 2){
              if(this.$store.state.dashboard.options.checkedrows[0] != null && this.$store.state.dashboard.options.checkedrows[1] != null){
                this.$store.dispatch('UpdateUserAction','overlay')
              }
            }else if(this.$store.state.dashboard.options.checkedrows.length < 2){
              this.$buefy.toast.open({
                duration: 2000,
                message: this.$t("app.dashboard.warn.under"),
                position: "is-top",
                type: "is-danger"
              });
            }else if(this.$store.state.dashboard.options.checkedrows.length > 2){
              this.$buefy.toast.open({
                duration: 2000,
                message: this.$t("app.dashboard.warn.over"),
                position: "is-top",
                type: "is-danger"
              });
            }
        },
        setpath(){
            let path = ""
            this.$store.state.dashboard.options.checkedrows.forEach(element => {
                path += "&" + element.VariableID
            });
            return path
        },
        ...mapActions({
            'getGroup': 'groups/getGroup',
            'Userflag': 'dashboard/Userflag'
        })
    }
})
</script>
<style scoped>
.btn-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.btn-list li {
  margin: 10px;
}

.btn {
  display: block;
  position: relative;
  padding: 15px 20px 15px 40px;
  border-radius: 4px;
  background: #2c6ac4;
  color: #fff;
  text-decoration: none;
}
.btn-graph:before {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  font-size: 1.25rem;
  font-family: 'Font Awesome 5 Free';
  content: "\f1fe";
  font-weight: 900;
}
.btn-square-little-rich {
  text-align: center;
  position: relative;
  display: inline-block;
  padding: 10px 5px;
  text-decoration: none;
  color: #FFF;
  background:#2c6ac4;/*色*/
  border: solid 1px #2c6ac4;/*線色*/
  border-radius: 4px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.2);
  text-shadow: 0 1px 0 rgba(0,0,0,0.2);
  margin: 10px 15px;
  width: 250px;
  height: 50px;
}

.btn-square-little-rich:active {
  /*押したとき*/
  border: solid 1px #2c6ac4;
  box-shadow: none;
  text-shadow: none;
}
.button_text{
  padding: 30px 10px;
}
#loader
{
  display: inline-block;
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 4px solid #fff;
  border-right-color: transparent;
  animation: spin 1s linear infinite;
}
@keyframes spin
{
    0% { transform: rotate(0deg)}
    50%  { transform: rotate(180deg)}
    100%   { transform: rotate(360deg)}
}
</style>
